// A tab left open never reloads its page, so it can run an old release for days (4 Nov: a new field didn't show until a
// hard refresh). When the tab comes back into focus, at most every 5 minutes, this compares the page's own bundle with
// the one the server's page names and offers a reload. It never reloads by itself: a half-typed form stays safe.
import React from 'react';

export const CHECK_EVERY_MS = 5 * 60_000;
export const UPDATED_WORDS = 'MatchPoint has been updated';
const BUNDLE = /\/assets\/index-[^"'\s]+\.js/;

/** The main bundle a page's HTML names, or null. */
export const bundleIn = (html: string): string | null => html.match(BUNDLE)?.[0] ?? null;

const mine = (): string | null => {
  const tag = Array.from(document.scripts).map(s => s.getAttribute('src') ?? '').find(src => BUNDLE.test(src));
  return tag ? bundleIn(tag) : null;
};

const UpdateBar: React.FC = () => {
  const [updated, setUpdated] = React.useState(false);
  React.useEffect(() => {
    const running = mine();
    if (!running) return undefined;                       // the dev server has no built bundle to compare
    let last = Date.now();
    const check = async () => {
      if (document.visibilityState === 'hidden' || Date.now() - last < CHECK_EVERY_MS) return;
      last = Date.now();
      try {
        const r = await fetch('/index.html', { cache: 'no-cache', credentials: 'same-origin' });
        const now = r.ok ? bundleIn(await r.text()) : null;
        if (now && now !== running) setUpdated(true);
      } catch { /* offline: try at the next focus */ }
    };
    window.addEventListener('focus', check);
    document.addEventListener('visibilitychange', check);
    return () => { window.removeEventListener('focus', check); document.removeEventListener('visibilitychange', check); };
  }, []);
  if (!updated) return null;
  return (
    <div role="status" data-testid="update-bar" className="flex items-center justify-center gap-mp-2 bg-mp-info-bg px-mp-3 py-1 text-mp-sm">
      {UPDATED_WORDS}
      <button type="button" className="font-medium text-mp-accent hover:underline" onClick={() => window.location.reload()}>Reload</button>
    </div>);
};

export default UpdateBar;
